var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {Component, PropSync, Vue} from "vue-property-decorator";
let CompanyResult = class extends Vue {
  returnToVerify() {
    this.$emit("toVerify");
  }
  contextUs() {
    window.open("https://www.kuajingvs.com/contact", "_blank");
  }
};
__decorateClass([
  PropSync("verifyStatus", {type: String, default: function() {
    return "waiting";
  }})
], CompanyResult.prototype, "verify_status", 2);
__decorateClass([
  PropSync("message", {type: String, default: function() {
    return "";
  }})
], CompanyResult.prototype, "company_info", 2);
__decorateClass([
  PropSync("reason", {type: String, default: function() {
    return "";
  }})
], CompanyResult.prototype, "fail_reason", 2);
CompanyResult = __decorateClass([
  Component({
    components: {}
  })
], CompanyResult);
export default CompanyResult;
